export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";